import {    srcGen,
  settings,
} from 'crossasia-itr-solr-setting'
import {groups} from './groups.js'

const endpoint = process.env.SOLR_SERVER
const solrServer = process.env.SOLR_SERVER

const fieldsMapping = {}
const info = {}


delete settings["itr-rmrb2"]
delete settings["itr-dagongbao2"]
delete settings["itr-dagongbao3"]
delete settings["itr-proquest-chinnewspaper-2"]
delete settings["itr-Neueste-Mittheilungen"]

delete settings["itr-shenbao2"]
delete settings["itr-shenbao"]

delete settings["itr-ungl2"]
delete settings["itr-tjtstj2"]
delete settings["itr-gale-tda2"]
// delete fieldsMapping["itr-tjtj"]

Object.entries(settings).forEach(([key, value]) => {
  fieldsMapping[key] = value.dataSetting
  const [infoKey, infoValue] = Object.entries(value.info)[0]
  info[infoKey] = infoValue
})

const sources = Object.keys(fieldsMapping).reduce((acc, x) => {
  acc[x] = srcGen(x, "",solrServer)
  return acc
},{})

export {
  sources,
  info,
  fieldsMapping,
  groups,
  endpoint,
  solrServer
}

export default {
  sources,
  info,
  fieldsMapping,
  groups,
  endpoint,
  solrServer
}



//////////////////
// WEBPACK FOOTER
// /data/code/gitlab/crossasia-itr-fulltextsearch-setting/index.js
// module id = U7BI
// module chunks = 1